module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlain.20303ab.webp";